import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">AG</span>
              </div>
              <div>
                <h3 className="text-xl font-bold">Auto-Glass Mannheim</h3>
                <p className="text-gray-400">Professionelle Autoglas Reparatur</p>
              </div>
            </div>
            <p className="text-gray-300 mb-4">
              Ihr vertrauensvoller Partner für professionelle Autoglas Reparatur und Austausch 
              in Mannheim, Frankfurt und Stuttgart. Qualität, Zuverlässigkeit und faire Preise.
            </p>
            <div className="flex space-x-4">
              <a
                href="tel:062171895675"
                className="flex items-center space-x-2 text-blue-400 hover:text-blue-300 transition-colors"
              >
                <Phone size={16} />
                <span>0621 71895675</span>
              </a>
              <a
                href="mailto:info@autoglass-mannheim.de"
                className="flex items-center space-x-2 text-blue-400 hover:text-blue-300 transition-colors"
              >
                <Mail size={16} />
                <span>info@autoglass-mannheim.de</span>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Unsere Leistungen</h4>
            <ul className="space-y-2 text-gray-300">
              <li>
                <Link to="/services" className="hover:text-white transition-colors">
                  Autoglas Reparatur
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-white transition-colors">
                  Autoglas Austausch
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-white transition-colors">
                  Scheibenversiegelung
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-white transition-colors">
                  Notfall Service
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-white transition-colors">
                  Mobile Reparatur
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact & Hours */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Kontakt & Öffnungszeiten</h4>
            <div className="space-y-3 text-gray-300">
              <div className="flex items-start space-x-2">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <div>
                  <p>Mannheim, Frankfurt</p>
                  <p>Stuttgart</p>
                </div>
              </div>
              <div className="flex items-start space-x-2">
                <Clock size={16} className="mt-1 flex-shrink-0" />
                <div>
                  <p>Mo-Fr: 8:00 - 18:00</p>
                  <p>Sa: 9:00 - 14:00</p>
                  <p>Notfall: 24/7</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © {currentYear} Auto-Glass Mannheim. Alle Rechte vorbehalten.
            </div>
            <div className="flex space-x-6 text-sm">
              <Link to="/impressum" className="text-gray-400 hover:text-white transition-colors">
                Impressum
              </Link>
              <Link to="/datenschutz" className="text-gray-400 hover:text-white transition-colors">
                Datenschutz
              </Link>
              <Link to="/agb" className="text-gray-400 hover:text-white transition-colors">
                AGB
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 